export const countryTranslations = {
    ad: Lang.get('locale.country.AD'),
    ae: Lang.get('locale.country.AE'),
    af: Lang.get('locale.country.AF'),
    ag: Lang.get('locale.country.AG'),
    ai: Lang.get('locale.country.AI'),
    al: Lang.get('locale.country.AL'),
    am: Lang.get('locale.country.AM'),
    ao: Lang.get('locale.country.AO'),
    ar: Lang.get('locale.country.AR'),
    as: Lang.get('locale.country.AS'),
    at: Lang.get('locale.country.AT'),
    au: Lang.get('locale.country.AU'),
    aw: Lang.get('locale.country.AW'),
    ax: Lang.get('locale.country.AX'),
    az: Lang.get('locale.country.AZ'),
    ba: Lang.get('locale.country.BA'),
    bb: Lang.get('locale.country.BB'),
    bd: Lang.get('locale.country.BD'),
    be: Lang.get('locale.country.BE'),
    bf: Lang.get('locale.country.BF'),
    bg: Lang.get('locale.country.BG'),
    bh: Lang.get('locale.country.BH'),
    bi: Lang.get('locale.country.BI'),
    bj: Lang.get('locale.country.BJ'),
    bl: Lang.get('locale.country.BL'),
    bm: Lang.get('locale.country.BM'),
    bn: Lang.get('locale.country.BN'),
    bo: Lang.get('locale.country.BO'),
    bq: Lang.get('locale.country.BQ'),
    br: Lang.get('locale.country.BR'),
    bs: Lang.get('locale.country.BS'),
    bt: Lang.get('locale.country.BT'),
    bw: Lang.get('locale.country.BW'),
    by: Lang.get('locale.country.BY'),
    bz: Lang.get('locale.country.BZ'),
    ca: Lang.get('locale.country.CA'),
    cd: Lang.get('locale.country.CD'),
    cf: Lang.get('locale.country.CF'),
    cg: Lang.get('locale.country.CG'),
    ch: Lang.get('locale.country.CH'),
    ci: Lang.get('locale.country.CI'),
    ck: Lang.get('locale.country.CK'),
    cl: Lang.get('locale.country.CL'),
    cm: Lang.get('locale.country.CM'),
    cn: Lang.get('locale.country.CN'),
    co: Lang.get('locale.country.CO'),
    cr: Lang.get('locale.country.CR'),
    cu: Lang.get('locale.country.CU'),
    cv: Lang.get('locale.country.CV'),
    cw: Lang.get('locale.country.CW'),
    cy: Lang.get('locale.country.CY'),
    cz: Lang.get('locale.country.CZ'),
    de: Lang.get('locale.country.DE'),
    dj: Lang.get('locale.country.DJ'),
    dk: Lang.get('locale.country.DK'),
    dm: Lang.get('locale.country.DM'),
    do: Lang.get('locale.country.DO'),
    dz: Lang.get('locale.country.DZ'),
    ec: Lang.get('locale.country.EC'),
    ee: Lang.get('locale.country.EE'),
    eg: Lang.get('locale.country.EG'),
    eh: Lang.get('locale.country.EH'),
    er: Lang.get('locale.country.ER'),
    es: Lang.get('locale.country.ES'),
    et: Lang.get('locale.country.ET'),
    fi: Lang.get('locale.country.FI'),
    fj: Lang.get('locale.country.FJ'),
    fk: Lang.get('locale.country.FK'),
    fm: Lang.get('locale.country.FM'),
    fo: Lang.get('locale.country.FO'),
    fr: Lang.get('locale.country.FR'),
    ga: Lang.get('locale.country.GA'),
    gb: Lang.get('locale.country.GB'),
    gd: Lang.get('locale.country.GD'),
    ge: Lang.get('locale.country.GE'),
    gg: Lang.get('locale.country.GG'),
    gh: Lang.get('locale.country.GH'),
    gl: Lang.get('locale.country.GL'),
    gm: Lang.get('locale.country.GM'),
    gn: Lang.get('locale.country.GN'),
    gq: Lang.get('locale.country.GQ'),
    gr: Lang.get('locale.country.GR'),
    gt: Lang.get('locale.country.GT'),
    gu: Lang.get('locale.country.GU'),
    gw: Lang.get('locale.country.GW'),
    gy: Lang.get('locale.country.GY'),
    hk: Lang.get('locale.country.HK'),
    hn: Lang.get('locale.country.HN'),
    hr: Lang.get('locale.country.HR'),
    ht: Lang.get('locale.country.HT'),
    hu: Lang.get('locale.country.HU'),
    id: Lang.get('locale.country.ID'),
    ie: Lang.get('locale.country.IE'),
    il: Lang.get('locale.country.IL'),
    im: Lang.get('locale.country.IM'),
    in: Lang.get('locale.country.IN'),
    io: Lang.get('locale.country.IO'),
    iq: Lang.get('locale.country.IQ'),
    ir: Lang.get('locale.country.IR'),
    is: Lang.get('locale.country.IS'),
    it: Lang.get('locale.country.IT'),
    je: Lang.get('locale.country.JE'),
    jm: Lang.get('locale.country.JM'),
    jo: Lang.get('locale.country.JO'),
    jp: Lang.get('locale.country.JP'),
    ke: Lang.get('locale.country.KE'),
    kg: Lang.get('locale.country.KG'),
    kh: Lang.get('locale.country.KH'),
    ki: Lang.get('locale.country.KI'),
    km: Lang.get('locale.country.KM'),
    kn: Lang.get('locale.country.KN'),
    kp: Lang.get('locale.country.KP'),
    kr: Lang.get('locale.country.KR'),
    kw: Lang.get('locale.country.KW'),
    ky: Lang.get('locale.country.KY'),
    kz: Lang.get('locale.country.KZ'),
    la: Lang.get('locale.country.LA'),
    lb: Lang.get('locale.country.LB'),
    lc: Lang.get('locale.country.LC'),
    li: Lang.get('locale.country.LI'),
    lk: Lang.get('locale.country.LK'),
    lr: Lang.get('locale.country.LR'),
    ls: Lang.get('locale.country.LS'),
    lt: Lang.get('locale.country.LT'),
    lu: Lang.get('locale.country.LU'),
    lv: Lang.get('locale.country.LV'),
    ly: Lang.get('locale.country.LY'),
    ma: Lang.get('locale.country.MA'),
    mc: Lang.get('locale.country.MC'),
    md: Lang.get('locale.country.MD'),
    me: Lang.get('locale.country.ME'),
    mf: Lang.get('locale.country.MF'),
    mg: Lang.get('locale.country.MG'),
    mh: Lang.get('locale.country.MH'),
    mk: Lang.get('locale.country.MK'),
    ml: Lang.get('locale.country.ML'),
    mm: Lang.get('locale.country.MM'),
    mn: Lang.get('locale.country.MN'),
    mo: Lang.get('locale.country.MO'),
    mp: Lang.get('locale.country.MP'),
    mr: Lang.get('locale.country.MR'),
    ms: Lang.get('locale.country.MS'),
    mt: Lang.get('locale.country.MT'),
    mu: Lang.get('locale.country.MU'),
    mv: Lang.get('locale.country.MV'),
    mw: Lang.get('locale.country.MW'),
    mx: Lang.get('locale.country.MX'),
    my: Lang.get('locale.country.MY'),
    mz: Lang.get('locale.country.MZ'),
    na: Lang.get('locale.country.NA'),
    nc: Lang.get('locale.country.NC'),
    ne: Lang.get('locale.country.NE'),
    nf: Lang.get('locale.country.NF'),
    ng: Lang.get('locale.country.NG'),
    ni: Lang.get('locale.country.NI'),
    nl: Lang.get('locale.country.NL'),
    no: Lang.get('locale.country.NO'),
    np: Lang.get('locale.country.NP'),
    nr: Lang.get('locale.country.NR'),
    nu: Lang.get('locale.country.NU'),
    nz: Lang.get('locale.country.NZ'),
    om: Lang.get('locale.country.OM'),
    pa: Lang.get('locale.country.PA'),
    pe: Lang.get('locale.country.PE'),
    pf: Lang.get('locale.country.PF'),
    pg: Lang.get('locale.country.PG'),
    ph: Lang.get('locale.country.PH'),
    pk: Lang.get('locale.country.PK'),
    pl: Lang.get('locale.country.PL'),
    pm: Lang.get('locale.country.PM'),
    pr: Lang.get('locale.country.PR'),
    ps: Lang.get('locale.country.PS'),
    pt: Lang.get('locale.country.PT'),
    pw: Lang.get('locale.country.PW'),
    py: Lang.get('locale.country.PY'),
    qa: Lang.get('locale.country.QA'),
    ro: Lang.get('locale.country.RO'),
    rs: Lang.get('locale.country.RS'),
    ru: Lang.get('locale.country.RU'),
    rw: Lang.get('locale.country.RW'),
    sa: Lang.get('locale.country.SA'),
    sb: Lang.get('locale.country.SB'),
    sc: Lang.get('locale.country.SC'),
    sd: Lang.get('locale.country.SD'),
    se: Lang.get('locale.country.SE'),
    sg: Lang.get('locale.country.SG'),
    sh: Lang.get('locale.country.SH'),
    si: Lang.get('locale.country.SI'),
    sk: Lang.get('locale.country.SK'),
    sl: Lang.get('locale.country.SL'),
    sm: Lang.get('locale.country.SM'),
    sn: Lang.get('locale.country.SN'),
    so: Lang.get('locale.country.SO'),
    sr: Lang.get('locale.country.SR'),
    ss: Lang.get('locale.country.SS'),
    st: Lang.get('locale.country.ST'),
    sv: Lang.get('locale.country.SV'),
    sx: Lang.get('locale.country.SX'),
    sy: Lang.get('locale.country.SY'),
    sz: Lang.get('locale.country.SZ'),
    tc: Lang.get('locale.country.TC'),
    td: Lang.get('locale.country.TD'),
    tg: Lang.get('locale.country.TG'),
    th: Lang.get('locale.country.TH'),
    tj: Lang.get('locale.country.TJ'),
    tl: Lang.get('locale.country.TL'),
    tm: Lang.get('locale.country.TM'),
    tn: Lang.get('locale.country.TN'),
    to: Lang.get('locale.country.TO'),
    tr: Lang.get('locale.country.TR'),
    tt: Lang.get('locale.country.TT'),
    tv: Lang.get('locale.country.TV'),
    tw: Lang.get('locale.country.TW'),
    tz: Lang.get('locale.country.TZ'),
    ua: Lang.get('locale.country.UA'),
    ug: Lang.get('locale.country.UG'),
    us: Lang.get('locale.country.US'),
    uy: Lang.get('locale.country.UY'),
    uz: Lang.get('locale.country.UZ'),
    va: Lang.get('locale.country.VA'),
    vc: Lang.get('locale.country.VC'),
    ve: Lang.get('locale.country.VE'),
    vg: Lang.get('locale.country.VG'),
    vi: Lang.get('locale.country.VI'),
    vn: Lang.get('locale.country.VN'),
    vu: Lang.get('locale.country.VU'),
    wf: Lang.get('locale.country.WF'),
    ws: Lang.get('locale.country.WS'),
    ye: Lang.get('locale.country.YE'),
    za: Lang.get('locale.country.ZA'),
    zm: Lang.get('locale.country.ZM'),
    zw: Lang.get('locale.country.ZW'),
};
